module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTfO1D3y9D////hSFv52Nxs8yivAAAACHRSTlMAYL//ACDP71kzCuAAAAEgSURBVHja7djNEoIwDATgQgET9f2fVzjtYbVrkxw8uMfO5GMK/RnSrixrT2RdtjNt2/ajJ3PsF7Tfejq3/YSOXpBja0svydLWGmhtvSh/6Icg8/unuM1AcDg+A91HeVRBganlIfMwpORnGoKTh+BoSDt5CM4zB8GxGMROj0HsxCB2YhA7MYidGMROHGJHQ9r5GjITjoJw+rhJR0OOgoGjIaMSciYgFJEzOTWUsaMhKhw4AiKJHcQHNy1JAwfrhCGWBg7CEEtwYhAkdjTEEpwgBAlOPVQ/tfqXXf/56xek3iKc5KZFcseIhrgQA66h9w4N2QzkcAifgYwcSN5nIDji0pRTgzOfRs/+/9P+PlTWZClr+1Q1ospaY5XNujMV7cMXkGpXAHuYdjsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2650.png
// module id = 1358
// module chunks = 0